module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-SemiboldIt.3d56bd0a.ttf";